import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { Form, Input, Divider } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import { compose } from 'redux'
import { trim } from 'lodash'
import { withNamespaces } from '@edulastic/localization'
import { connect } from 'react-redux'
import {
  withWindowSizes,
  notification,
  EduIf,
  FlexContainer,
} from '@edulastic/common'
import { IconLock, IconUser, IconMail } from '@edulastic/icons'

import { segmentApi } from '@edulastic/api'
import { placeholderPrefixColor } from '@edulastic/colors'
import { MAX_TAB_WIDTH } from '../../../../author/src/constants/others'
import {
  RegistrationWrapper,
  RegistrationHeader,
  LinkDiv,
  ThirdPartyLoginBtn,
  FormBody,
  RegisterButton,
  PsiContainer,
  RightContainer,
  BoldText,
  CreateAccountDivider,
  StyledButtonText,
  SignUpHeader,
  SignUpContainer,
} from '../../styled'
import {
  signupAction,
  googleLoginAction,
  msoLoginAction,
} from '../../../Login/ducks'
import {
  getPartnerKeyFromUrl,
  validatePartnerUrl,
  getPartnerLoginUrl,
  getPartnerStudentSignupUrl,
  getPartnerTeacherSignupUrl,
  isEmailValid,
  updateMetaTag,
  removeMetaTag,
} from '../../../../common/utils/helpers'
import { Partners } from '../../../../common/utils/static/partnerData'

import adminBg from '../../../assets/bg-adm.png'
import googleIcon from '../../../assets/google-btn.svg'
import icon365 from '../../../assets/icons8-office-365.svg'

import { isPearDomain } from '../../../../../utils/pear'

import { LeftContainer } from '../LeftContainer'

const FormItem = Form.Item

class AdminSignup extends React.Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    signup: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  }

  state = {
    confirmDirty: false,
    signupError: {},
  }

  componentDidMount() {
    if (window?.analytics?.track) {
      window.analytics.track('SignupLanded', {
        role: 'admin',
        referrer: window.document.referrer,
      })
    }
    updateMetaTag({
      content: 'Pear Assessment for Administrators',
    })
  }

  componentWillUnmount() {
    removeMetaTag() // Removing description meta tag
  }

  handleSubmit = (e) => {
    const { form, signup } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll((err, { password, email, name }) => {
      if (!err) {
        segmentApi.genericEventTrack('Signup_ButtonClick', { Method: 'Email' })
        signup({
          password,
          email,
          name,
          role: 'teacher',
          errorCallback: this.errorCallback,
          isAdmin: true,
        })
      }
    })
  }

  handleConfirmBlur = ({ target: { value } }) => {
    let { confirmDirty } = this.state
    confirmDirty = confirmDirty || !!value
    this.setState({ confirmDirty })
  }

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!')
    } else {
      callback()
    }
  }

  onChangeEmail = () => {
    this.setState((state) => ({
      ...state,
      signupError: {
        ...state.signupError,
        email: '',
      },
    }))
  }

  errorCallback = (error) => {
    if (error === 'Email already exists. Please sign in to your account.') {
      this.setState((state) => ({
        ...state,
        signupError: {
          ...state.signupError,
          email: 'error',
        },
      }))
    } else {
      notification({ msg: error })
    }
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldError },
      t,
      googleLoginAction,
      msoLoginAction,
      windowWidth,
    } = this.props

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
      },
    }

    const partnerKey = getPartnerKeyFromUrl(location.pathname)
    const partner = Partners[partnerKey]

    const emailError =
      (this.state.signupError.email && (
        <span>
          Email already exists. Please{' '}
          <Link to={getPartnerLoginUrl(partner)}>sign in</Link> to your account.
        </span>
      )) ||
      getFieldError('email')

    return (
      <div>
        {!validatePartnerUrl(partner) ? <Redirect exact to="/" /> : null}
        <RegistrationWrapper
          image={partner.partnerKey === 'login' ? adminBg : partner.background}
        >
          {windowWidth > MAX_TAB_WIDTH && (
            <LeftContainer currentPage="adminsignup" />
          )}
          <RightContainer windowWidth={windowWidth}>
            <Helmet>
              <link
                rel="canonical"
                href="https://assessment.peardeck.com/adminsignup"
              />
            </Helmet>
            <RegistrationHeader type="flex" align="middle">
              <span>{t('component.signup.alreadyhaveanaccount')}</span>
              <Link
                onClick={() =>
                  segmentApi.genericEventTrack(
                    'SignupPage_SigninButtonClick',
                    {}
                  )
                }
                to={getPartnerLoginUrl(partner)}
              >
                {t('component.signup.signinbtn')}
              </Link>
            </RegistrationHeader>
            <SignUpContainer>
              <SignUpHeader>Sign up As Administrator</SignUpHeader>
              <EduIf condition={isPearDomain}>
                <PsiContainer width="100%">
                  <div id="psi_sign_in" />
                </PsiContainer>
              </EduIf>
              <ThirdPartyLoginBtn
                span={20}
                offset={2}
                onClick={() => {
                  googleLoginAction({
                    role: 'teacher',
                    isAdmin: true,
                  })
                }}
              >
                <img src={googleIcon} alt="Google" />{' '}
                <StyledButtonText>
                  {t('component.signup.googlesignupbtn')}
                </StyledButtonText>
              </ThirdPartyLoginBtn>
              <ThirdPartyLoginBtn
                span={20}
                offset={2}
                onClick={() => {
                  msoLoginAction({
                    role: 'teacher',
                    isAdmin: true,
                  })
                }}
              >
                <img src={icon365} alt="Office 365" />{' '}
                <StyledButtonText>
                  {t('component.signup.office365signupbtn')}
                </StyledButtonText>
              </ThirdPartyLoginBtn>

              <CreateAccountDivider>
                {t('component.signup.formboxheading')}
              </CreateAccountDivider>
              <FormBody>
                <Form onSubmit={this.handleSubmit}>
                  <FormItem {...formItemLayout}>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: t('component.signup.admin.validinputname'),
                        },
                      ],
                    })(
                      <Input
                        placeholder="Administrator Name"
                        prefix={<IconUser color={placeholderPrefixColor} />}
                      />
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    validateStatus={emailError ? 'error' : 'success'}
                    help={emailError}
                  >
                    {getFieldDecorator('email', {
                      validateFirst: true,
                      initialValue: '',
                      rules: [
                        {
                          transform: (value) => trim(value),
                        },
                        {
                          required: true,
                          message: t('common.validation.emptyemailid'),
                        },
                        {
                          type: 'string',
                          message: t('common.validation.validemail'),
                        },
                        {
                          validator: (rule, value, callback) =>
                            isEmailValid(
                              rule,
                              value,
                              callback,
                              'email',
                              t('common.validation.validemail')
                            ),
                        },
                      ],
                    })(
                      <Input
                        prefix={<IconMail color={placeholderPrefixColor} />}
                        type="email"
                        onChange={this.onChangeEmail}
                        placeholder="Administrator Email"
                      />
                    )}
                  </FormItem>
                  <FormItem {...formItemLayout}>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: t('common.validation.emptypassword'),
                        },
                      ],
                    })(
                      <Input
                        prefix={<IconLock color={placeholderPrefixColor} />}
                        type="password"
                        autoComplete="off"
                        placeholder="Password"
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    <RegisterButton type="primary" htmlType="submit">
                      {t('component.signup.admin.signupadminbtn')}
                    </RegisterButton>
                  </FormItem>
                </Form>
              </FormBody>
              <Divider />
              <FlexContainer
                width="100%"
                style={{ gap: '20px' }}
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <BoldText>Not a administrator?</BoldText>
                <div>
                  <LinkDiv>
                    <Link to={getPartnerTeacherSignupUrl(partner)}>
                      {t('component.signup.signupasteacher')}
                    </Link>
                  </LinkDiv>
                  <LinkDiv>
                    <Link to={getPartnerStudentSignupUrl(partner)}>
                      {t('component.signup.signupasstudent')}
                    </Link>
                  </LinkDiv>
                </div>
              </FlexContainer>
            </SignUpContainer>
          </RightContainer>
        </RegistrationWrapper>
      </div>
    )
  }
}

const SignupForm = Form.create()(AdminSignup)

const enhance = compose(
  withNamespaces('login'),
  withWindowSizes,
  connect(null, { signup: signupAction, googleLoginAction, msoLoginAction })
)

export default enhance(SignupForm)
